import { render, staticRenderFns } from "./Sportfile.vue?vue&type=template&id=aa12aee6&"
import script from "./Sportfile.vue?vue&type=script&lang=js&"
export * from "./Sportfile.vue?vue&type=script&lang=js&"
import style0 from "./Sportfile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports